import { render, staticRenderFns } from "./SearchInitialState.vue?vue&type=template&id=2d24c200&scoped=true&"
import script from "./SearchInitialState.vue?vue&type=script&lang=js&"
export * from "./SearchInitialState.vue?vue&type=script&lang=js&"
import style0 from "./SearchInitialState.vue?vue&type=style&index=0&id=2d24c200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d24c200",
  null
  
)

export default component.exports